const ZENDESK_SNIPPET_ID = 'ze-snippet';
const ZENDESK_SNIPPET_SRC =
  'https://static.zdassets.com/ekr/snippet.js?key=bc557a7c-11a5-450a-a0d0-5a30d21e6288';

const ZENDESK_WIDGET_SETTINGS = {
  webWidget: {
    position: { horizontal: 'right', vertical: 'bottom' },
  },
};

const showWidget = () => {
  window.zE?.('webWidget', 'updateSettings', ZENDESK_WIDGET_SETTINGS);
  window.zE?.('webWidget', 'open');
  window.zE?.('webWidget', 'show');
};

export const openZendeskWidget = () => {
  if (window.zE) {
    showWidget();
    return;
  }

  if (document.getElementById(ZENDESK_SNIPPET_ID)) {
    return;
  }

  window.zESettings = ZENDESK_WIDGET_SETTINGS;

  const script = document.createElement('script');
  script.id = ZENDESK_SNIPPET_ID;
  script.src = ZENDESK_SNIPPET_SRC;
  script.onload = () => {
    window.zE?.('webWidget:on', 'close', () =>
      window.zE?.('webWidget', 'hide')
    );
    showWidget();
  };
  document.body.appendChild(script);
};
